module.exports = __webpack_public_path__ + "img/trapezoid.969490d1.svg";